'use strict'

const mapKeys_ = require('lodash/mapKeys')
const startsWith_ = require('lodash/startsWith')
const assign_ = require('lodash/assign')
const get_ = require('lodash/get')
const maybe = require('folktale/maybe')

const { FIELD_TYPES } = require('dbsm-common/src/collections/consts')

const dynamicPropertiesHandlers = {
  $text: (fieldType) => fieldType === FIELD_TYPES.RICHTEXT ? 'html' : 'text'
}

const resolveDynamicProperty = (propName, propertyConfig, getFieldType) =>
  maybe
    .fromNullable(dynamicPropertiesHandlers[propName])
    .map(propHandler => {
      const fieldType = getFieldType(propertyConfig.fieldName)
      return propHandler(fieldType)
    })
    .getOrElse(propName)

exports.resolveDynamicProperties = ({ connectionConfig }, role, getFieldType) =>
  maybe
    .fromNullable(get_(connectionConfig, 'properties'))
    .map(properties =>
      mapKeys_(
        connectionConfig.properties,
        (property, propName) =>
          startsWith_(propName, '$')
            ? resolveDynamicProperty(propName, property, getFieldType)
            : propName
      )
    )
    .map(properties => assign_({}, connectionConfig, { properties }))
    .getOrElse(connectionConfig)



// WEBPACK FOOTER //
// ./dataset-controller/dynamicProperties.js